import {
  sizes,
  variants,
  LgPageProps,
  variantsTextField,
} from "@affinitysystemsgroup/github-packages-affinity-components/dist";

const bgImage = "/assets/img/GradientfromAssurehub.svg";
const logo = "/assets/img/AssurehubLogo.png";
const logoSSO = "/assets/img/MicrosoftLogofromAssurehub.png";

export const loginCT: LgPageProps = {
  bgImage: bgImage,
  title: "Inicia Sesión",
  logo: logo,
  sso: {
    logo: logoSSO,
    title: "Ingresar con Microsoft",
  },
  inputEmail: {
    id: "email",
    label: "Correo",
    placeholder: "Ingresa tu correo",
    variant: variantsTextField.outlined,
  },
  inputPassword: {
    id: "password",
    label: "Contraseña",
    variant: variantsTextField.outlined,
  },
  btnLogin: {
    label: "Iniciar sesion",
    variant: variants.outlined,
  },
};
